module.exports = "<div>\n  <img src={{blogImg}}>\n</div>\n"